/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import React from 'react';
import { NavLink } from 'react-router-dom';
import './NavigationItem.css';

const NavigationItem = (props) => (
	<li className="navigation-item">
		<NavLink to={props.link} exact={props.exact} onClick={props.toggle}>
			{props.children}
		</NavLink>
	</li>
);

export default NavigationItem;
